import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";
import { NewsFiltersValues, NewsFormValues } from "../domain/models/News";

export const NewsFiltersFields: Fields<NewsFiltersValues> = {
    title: {
        min: 2,
        max: 50,
        placeholderKey: "console.news.table.title",
        type: "text",
        optional: true,
        initial: "",
    },
    shortContent: {
        min: 2,
        max: 250,
        placeholderKey: "console.news.table.shortContent",
        type: "text",
        optional: true,
        initial: "",
    },
    content: {
        min: 2,
        max: 1_000_000,
        placeholderKey: "console.news.table.content",
        type: "text",
        optional: true,
        initial: "",
    },
    creatorId: {
        min: 1,
        max: 50,
        placeholderKey: "console.news.table.creatorId",
        type: "text",
        optional: true,
        initial: "",
    },
};

export const NewsFields: Fields<NewsFormValues> = {
    files: {
        type: "files",
        optional: true,
        initial: [],
    },
    translations: {
        objectArray: {
            title: {
                min: 2,
                max: 50,
                placeholderKey: "console.news.table.title",
                type: "text",
                optional: false,
                initial: "",
            },
            shortContent: {
                min: 2,
                max: 250,
                placeholderKey: "console.news.table.shortContent",
                type: "text",
                optional: false,
                initial: "",
            },
            content: {
                min: 1,
                max: 1_000_000,
                placeholderKey: "console.news.table.content",
                type: "richtext",
                optional: true,
                initial: "",
            },
            // Fields that are set programmatically (not by the user, from entity)
            newsId: {
                type: "hidden",
                optional: true,
                initial: "",
            },
            languageCode: {
                type: "hidden",
                optional: true,
                initial: "",
            },
        },
        initial: [],
    },
};

export const newsFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, NewsFiltersFields);
};

export const newsSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, NewsFields);
};
